import { ref, watch }   from "vue";
import { useRoute }     from "vue-router";
import { useLocale }    from "../locales/i18n.js";

import {
    getMemberAvatar,
    getMemberDisplayName,
    useFetch,
} from "../utils.js";

import { createDiscordMarkdownParser, parseDiscordMarkdown }    from "../utils/markdown.js";
import { renderMarkdownAST }                                    from "../utils/markdownRenderer.js";
import ImageFallback                                            from "../components/imageFallback.js";


//////////////////////////////////////////////////
//  CHANNELS
//////////////////////////////////////////////////


export default {

    setup() {
        const markdown          = createDiscordMarkdownParser();
        const route             = useRoute();
        const { i18n }          = useLocale();
        const { fetch }         = useFetch();
        const refLoading        = ref(true);
        const refShowMarkdown   = ref(true);
        const refChannel        = ref(null);

        watch(() => route.params["id"], async (channelId) => {
            // refChannel.value = await fetch(`/api/channels/${channelId}`).then((res) => res.json());

            // console.log(refChannel.value);

            try {
                refLoading.value = true;

                const messages  = new Map();
                const members   = new Map();
                const logs      = [];

                {
                    let offset = "";

                    while (true) {
                        const res = await fetch(`/api/logs?before=${offset}`, {
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                types       : [ "message_create", "message_edit", "message_delete", "message_bulk_delete" ],
                                channels    : [ channelId ],
                            }),
                            method: "POST",
                        }).then((res) => res.json());

                        for (const member of res.members)
                            members.set(member.id, member);

                        for (const log of res.result)
                            if (log.channel === channelId)
                                logs.push(log);

                        if (res.result.length === 0)
                            break;

                        offset = res.result.at(-1).createdAt;
                    }
                }

                for (const log of logs.sort((a, b) => (a.createdAt - b.createdAt))) {
                    switch (log.type) {
                        case "message_create": {
                            log.edits       = [ log.content ];
                            log.executor    = members.get(log.executor);

                            messages.set(log.message, log);

                            break;
                        }

                        case "message_delete": {
                            const message = messages.get(log.message);

                            if (message) {
                                message.deleted = true;

                            } else {
                                console.warn(`Deleted message but not found in cache "${log.message}".`);
                            }

                            break;
                        }

                        case "message_edit": {
                            const message = messages.get(log.message);

                            if (message) {
                                message.edits.push(log.content);
                                message.edited = true;

                            } else {
                                console.warn(`Edited message but not found in cache "${log.message}".`);
                            }

                            break;
                        }
                    }
                }

                for (const message of messages.values())
                    message.edits.push(parseDiscordMarkdown(markdown, message.edits.at(-1)));

                refChannel.value = { messages, members };

            } finally {
                refLoading.value = false;
            }
        }, { immediate: true });

        window.toggleMarkdown = () => refShowMarkdown.value = !refShowMarkdown.value;

        function renderMessage(message) {
            return (
                <div>
                    <div class="log-message">
                        <router-link to={`/users/${message.executor.id}`} class="log-message-author-avatar">
                            <ImageFallback src={getMemberAvatar(message.executor)} default="https://cdn.discordapp.com/embed/avatars/0.png" alt={getMemberDisplayName(message.executor)} />
                        </router-link>

                        <router-link to={`/users/${message.executor.id}`} class="log-message-author-name">
                            {getMemberDisplayName(message.executor)}
                        </router-link>

                        <div class="log-message-content">
                            {refShowMarkdown.value
                                ? renderMarkdownAST(message.edits.at(-1))
                                : message.edits.at(-2)}
                        </div>
                    </div>

                    <div class="log-show-action">
                        {i18n("panel.showLogs.messageAction.created")}
                    </div>
                </div>
            );
        }

        return () => {
            if (refLoading.value)
                return <div class="notice">{i18n("panel.showLogs.loading_text")}</div>;

            const { messages } = refChannel.value;

            return (
                <div id="app">
                    {[...messages.values()].map(renderMessage)}
                </div>
            );
        };
    },
}
